import type { SATSeriesAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryLimitToSQL,
  queryOrderToSQL,
} from './common'
import SATTestQ from './SATTestQ'
import SeriesQ from './SeriesQ'

const SATSeriesQ = {
  ...makeQueryModelV2<SATSeriesAttributes>('sat_series')([
    'id',
    'series_id',
    'sat_test_id',
    'created_at',
    'deleted_at',
    'updated_at',
  ]),

  associations: (): AssociationDefinitions => ({
    Series: {
      query: SeriesQ,
      foreignKey: SeriesQ.id,
      sourceKey: SATSeriesQ.series_id,
    },
    SATTest: {
      query: SATTestQ,
      foreignKey: SATTestQ.id,
      sourceKey: SATSeriesQ.sat_test_id,
    },
  }),

  where: (
    {
      id = null,
      seriesId = null,
      satTestId = null,
      paranoid = true,
      include = [],
      order = null,
      limit = null,
    }: {
      id?: number | null | SQLFragment<number>
      seriesId?: number | null | SQLFragment<number>
      satTestId?: number | null | SQLFragment<number>
      paranoid?: boolean
      include?: IncludeAssociations
      order?: QueryOrder | null
      limit?: number | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<SATSeriesAttributes> => SQL`
        FROM ${SATSeriesQ}
        ${includeAssociationsToSql(SATSeriesQ, include)}
        WHERE
            ${id != null ? SQL`${SATSeriesQ.id} = ${id} AND` : SQL``}
            ${seriesId != null ? SQL`${SATSeriesQ.series_id} = ${seriesId} AND` : SQL``}
            ${satTestId != null ? SQL`${SATSeriesQ.sat_test_id} = ${satTestId} AND` : SQL``}
            ${paranoid ? SQL`${SATSeriesQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryOrderToSQL(order)}
        ${queryLimitToSQL(limit)}
    `,
}

export default SATSeriesQ
